export const queryParametersInitialState = {
  medium: null,
  source: null,
  partnerName: null
};
